module.exports = __webpack_public_path__ + "static/media/Jayun Translated by J_Lee_77777.1ebb1f37.md";